import { ApiWorkflowDialog } from '../../Dialog';

export type AppHeaderResetPasswordDialogProps = {
  onClose: () => void;
  userId: string;
};

export const AppHeaderResetPasswordDialog = (props: AppHeaderResetPasswordDialogProps) => {
  const { userId, onClose } = props;

  return (
    <ApiWorkflowDialog
      id="accountInfoDialog"
      title={'Reset password'}
      onClose={onClose}
      displayButtons={false}
      isValidForSubmit={true}
    >
      {'Reset password - coming soon - userId: ' + userId}
    </ApiWorkflowDialog>
  );
};
